import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../components/ui/table";
import { useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function HeadingTable() {
  const [headings, setHeadings] = useState<any[]>([]);
  const navigate = useNavigate();

  const featchheadings = async() => {
    const token = localStorage.getItem("token");

    const response = await fetch(`${apiUrl}/headings`, {
      headers: {
        "Content-Type": "application/json",
        "token": token || "",
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
      
    const result = await response.json();
    // console.log("headings:", result);

    if (result.success) {
      setHeadings(result.headings);
    } else {
      setHeadings([]);
    }
    
  }

  // Initial load
  useEffect(() => {
    featchheadings();
  }, []);
  

  const handleRowClick = (heading: any) => {
  navigate("/update-heading", { state: { heading } });
  
};

  return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Heading Type
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Display Order
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {headings.map((heading) => (
            <TableRow key={heading.inspectiontaskheading_id} className="cursor-pointer hover:bg-[#ffffa3]" onClick={() => handleRowClick(heading)}>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
              <span>{heading.name}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{heading.orderlevel}</span>
              </TableCell>
            </TableRow>
          ))} 
        </TableBody>
      </Table>  
    </>
  )
}